import {
  createElement,
  Accessibility, Activity, ArrowLeft, Bike, Bold, Building2, Bus, CalendarDays, Camera, Car,
  ChevronDown, ChevronRight, ChevronUp, CircleHelp, CircleParking, Coffee, Dumbbell, ExternalLink,
  Flag, Handshake, House, Info, Italic, Landmark, List, ListOrdered,
  LoaderCircle, LocateFixed, Map as MapIcon, MapPin, Menu, Music, Navigation, Palette, SlidersHorizontal,
  Quote, Redo2, Search, SearchX, ShoppingBag, Star, Trash2, Trees, Trophy, Undo2, Users, Utensils, X
} from "lucide";

const iconRegistry = {
  Accessibility, Activity, ArrowLeft, Bike, Bold, Building2, Bus, CalendarDays, Camera, Car,
  ChevronDown, ChevronRight, ChevronUp, CircleHelp, CircleParking, Coffee, Dumbbell, ExternalLink,
  Flag, Handshake, House, Info, Italic, Landmark, List, ListOrdered,
  LoaderCircle, LocateFixed, Map: MapIcon, MapPin, Menu, Music, Navigation, Palette, SlidersHorizontal,
  Quote, Redo2, Search, SearchX, ShoppingBag, Star, Trash2, Trees, Trophy, Undo2, Users, Utensils, X
};

export function iconHtml(key, classes = "size-4") {
  const pascal = (key || "map-pin").split("-").map(part => part[0].toUpperCase() + part.slice(1)).join("");
  const icon = iconRegistry[pascal] || MapPin;
  return createElement(icon, { class: classes, "aria-hidden": "true" }).outerHTML;
}
